// extracted by mini-css-extract-plugin
export default {"input":"EVLZf9fH"};